import type { IconData } from '@stacksjs/iconify-core'

export const starFull: IconData = {
  "body": "<path fill=\"currentColor\" d=\"m10 16.207l-6.173 3.246l1.179-6.874L.01 7.71l6.902-1.003L10 .453l3.087 6.254l6.902 1.003l-4.995 4.869l1.18 6.874z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default starFull
